// extracted by mini-css-extract-plugin
export default {"projectsGrid":"projects_projectsGrid__sSDxm","projectCard":"projects_projectCard__n6Hb6","projects":"projects_projects__pLbND","filter_box":"projects_filter_box__T+Xyy"};